/* eslint-disable @typescript-eslint/no-unused-vars */
import './styles.modules.scss';
import { MdKeyboardArrowLeft } from '@react-icons/all-files/md/MdKeyboardArrowLeft';
import { MdKeyboardArrowRight } from '@react-icons/all-files/md/MdKeyboardArrowRight';
import React, { useMemo } from 'react';
import Slider from 'react-slick';
import { Container } from 'reactstrap';

const HomeCategories: React.FC = () => {
  const settings = useMemo(
    () => ({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: <MdKeyboardArrowLeft />,
      nextArrow: <MdKeyboardArrowRight />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
          },
        },
      ],
    }),
    []
  );

  return (
    <Container styleName="categories-container">
      <h3>Categories</h3>
      <Slider {...settings}>
        <div id="top-image-1" styleName="categories-image">
          <a href="/list/apparel">
            <img
              src="/images/buyer/home/photo-1445205170230-053b83016050.webp"
              alt="category image"
              className="mb-2"
              loading="lazy"
            />
            <b>アパレル</b>
          </a>
        </div>
        <div id="top-image-4" styleName="categories-image">
          <a href="/list/subcategory/アクセサリー/ジュエリー・アクセサリー">
            <img
              src="/images/buyer/home/photo-1601057836844-a8a336439a27.webp"
              alt="category image"
              className="mb-2"
              loading="lazy"
            />
            <b>アクセサリー</b>
          </a>
        </div>
        <div id="top-image-2" styleName="categories-image">
          <a href="/list/accessories">
            <img
              src="/images/buyer/home/photo-1621252346441-c42a54aa8707.webp"
              alt="category image"
              className="mb-2"
              loading="lazy"
            />
            <b>ファッション雑貨</b>
          </a>
        </div>
        <div id="top-image-3" styleName="categories-image">
          <a href="/list/lifestyle">
            <img
              src="/images/buyer/home/photo-1506543730435-e2c1d4553a84.webp"
              alt="category image"
              className="mb-2"
              loading="lazy"
            />
            <b>ライフスタイル</b>
          </a>
        </div>
        <div id="top-image-5" styleName="categories-image">
          <a href="/list/beautyandwellness">
            <img
              src="/images/buyer/home/photo-1598440947619-2c35fc9aa908.webp"
              alt="category image"
              className="mb-2"
              loading="lazy"
            />
            <b>ビューティ・ウェルネス</b>
          </a>
        </div>
        <div id="top-image-6" styleName="categories-image">
          <a href="/list/Kidsbaby">
            <img
              src="/images/buyer/home/photo-1560506840-ec148e82a604.webp"
              alt="category image"
              className="mb-2"
              loading="lazy"
            />
            <b>キッズ・ベビー</b>
          </a>
        </div>
      </Slider>
    </Container>
  );
};

export default HomeCategories;
